<script>
    import { link } from "svelte-spa-router";
    import active from "svelte-spa-router/active";
</script>

<style>
    :global(a.active) {
        font-weight: bold;
    }
</style>

<nav>
    <a href="/" use:link use:active={'/'}>Home</a> |
    <a href="/cookbooks/" use:link use:active={'/cookbooks/*'}>Cookbooks</a> |
    <a href="/recipes/" use:link use:active={'/recipes/*'}>Recipes</a>
</nav>
